import React from "react";
import PropTypes from "prop-types";
import {
  StyledWrapper,
  StyledAnchor,
  StyledIcon,
  StyledItalicText,
} from "./_.styled";

const CinahlRedirectionLink = ({ redirectionLink }) => (
  <StyledWrapper>
    <StyledAnchor
      href={redirectionLink.link.href}
      data-testid={redirectionLink.link.testId}
      target="_blank"
    >
      <StyledIcon
        icon={{
          glyph: redirectionLink.icon.glyph,
          color: redirectionLink.icon.color,
          size: redirectionLink.icon.size,
          hideForPrint: true,
        }}
        data-testid={redirectionLink.icon.testId}
      />
      <span>{redirectionLink.link.label}</span>
    </StyledAnchor>
    <span> {redirectionLink.texts[0]} </span>
    <StyledItalicText>{redirectionLink.texts[1]}</StyledItalicText>
  </StyledWrapper>
);

CinahlRedirectionLink.propTypes = {
  redirectionLink: PropTypes.shape({
    link: PropTypes.shape({
      href: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      testId: PropTypes.string.isRequired,
    }).isRequired,
    icon: PropTypes.shape({
      glyph: PropTypes.string.isRequired,
      color: PropTypes.string.isRequired,
      size: PropTypes.string.isRequired,
      testId: PropTypes.string.isRequired,
    }).isRequired,
    texts: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
};

export default CinahlRedirectionLink;
